import {
	AfterViewChecked,
	AfterViewInit,
	Directive,
	ElementRef,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output, Renderer2,
} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {resizeObserver$} from "../../../utils/resize.halper";


@UntilDestroy()
@Directive({
	selector: '[cpHorizontalHiddenItemsNum]',
})
export class HorizontalHiddenItemsNumDirective implements AfterViewInit, OnInit{

	@Input() isAfterViewInitEnabled:boolean = true;
	@Output() onHiddenExternalItemsNum: EventEmitter<number> = new EventEmitter<number>()

	private resizeObservable$;
	constructor(public elementRef: ElementRef<HTMLElement>){

	}

	public ngOnInit(){
		/*this.resizeObservable$ = resizeObserver$(this.elementRef.nativeElement);
		this.resizeObservable$.pipe(
			untilDestroyed(this)).subscribe(entries=> {
		});*/
	}

	public ngAfterViewInit(): void {
		this.getHiddenExternalItemsNum();
	}

	public getHiddenExternalItemsNum() {
		var mainDivRec = this.elementRef.nativeElement.getClientRects()[0];
		if (mainDivRec) {
			var mainDivHorizantalEnd = mainDivRec.x + mainDivRec.width;

			var itemsRects = Array.prototype.slice.call(this.elementRef.nativeElement.children).map(x => x.getClientRects()[0]);
			// ignore the tab suppose to holds the number of hidden items
			itemsRects = itemsRects.slice(0, itemsRects.length - 1);

			var endIndex = itemsRects.findIndex(x => x !== undefined && mainDivHorizantalEnd < x.x + x.width) - 1;

			if (endIndex > 0) {
				this.onHiddenExternalItemsNum.emit(endIndex);
			}
		}
	}
}
